import { useMemo, useState } from "react";
import { useTable } from "react-table";
import {
  capitalizeLetter,
  convertToTilteCase,
  defaultDateDisplay,
} from "../../../../helpers";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";
import "../../../../assets/styles/base/globalPage.scss";
import primaryComponents from "../../../primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { DeleteIcon } from "../../../../assets/svgIcons";
import { smsCampaignStatus } from "../../../../localdata/smsCampaignStatus";

export const useSmsCampaignTable = ({ campaigns = [] }) => {
  const navigate = useNavigate();
  const [deleteCampaign, setDeleteCampaign] = useState(null);
  const [cancelCampaign, setCancelCampaign] = useState(null);

  const columns = useMemo(
    () => [
      {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "Campaign Name",
        accessor: "title",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ cell: { value } }) => (
          <span className={`${globalStyles[smsCampaignStatus?.[value]]}`}>
            {capitalizeLetter(value)}
          </span>
        ),
      },
      {
        Header: "Type",
        accessor: "delivery_type",
        Cell: ({ cell: { value } }) =>
          convertToTilteCase(value?.replace("_", " ")) || "N/A",
      },
      {
        Header: "Total Cost",
        accessor: "total_cost",
        Cell: ({ cell: { value } }) => (
          <span>
            {value} <span className="gray--text">credit</span>
          </span>
        ),
      },
      {
        Header: "No of Recipients",
        accessor: "recipient_count_estimate",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          const isActiveCampaign = ["SCHEDULED", "ONGOING"]?.includes(
            row?.original?.status,
          );

          return (
            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <primaryComponents.Button
                className="btn btn--primary smallBtn"
                onClick={() =>
                  navigate(
                    pathConstants.MARKETING_SMS_CAMPAIGNS_CONTEXT({
                      id: row?.original?.id,
                    }),
                  )
                }
              >
                Update
              </primaryComponents.Button>

              <primaryComponents.Button
                className={`btn ${isActiveCampaign ? "btn--outline-red" : "btn--outline"} smallBtn`}
                style={{ width: "80px" }}
                isDisabled={[
                  "COMPLETED",
                  "SENT",
                  "CANCELLED",
                  "DRAFT",
                ]?.includes(row?.original?.status)}
                onClick={() => {
                  if (isActiveCampaign) return setCancelCampaign(row?.original);

                  navigate(
                    pathConstants.MARKETING_SMS_CAMPAIGNS_REVIEW({
                      id: row?.original?.id,
                    }),
                  );
                }}
              >
                {isActiveCampaign ? "Pause" : "Activate"}
              </primaryComponents.Button>

              <span
                className="cursor-pointer"
                onClick={() => setDeleteCampaign(row?.original)}
              >
                <DeleteIcon />
              </span>
            </div>
          );
        },
      },
    ],
    [],
  );

  const instance = useTable({
    columns,
    data: campaigns || [],
  });

  return {
    instance,
    deleteCampaign,
    cancelCampaign,
    setCancelCampaign,
    setDeleteCampaign,
  };
};
